import { render } from "./RouteAbsences.vue?vue&type=template&id=4b5b9977&ts=true"
import script from "./RouteAbsences.vue?vue&type=script&lang=ts"
export * from "./RouteAbsences.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__